// Token
export const removeTokens = () => {
  localStorage.removeItem("connectionUuid");
  localStorage.removeItem("infrakitProjectUuid");
  localStorage.removeItem("infrakitToken");
};
